module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/images/background.7d3f33bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/images/background.jpg
// module id = 2543
// module chunks = 11